import React, { useEffect, useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  TableSortLabel
} from '@mui/material';
import { CustomButton, TableRowsSkeleton } from '../../shared';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { dataSourceHistoryByPage } from '../../../redux/thunks/dataSourcesThunk';
import {formatDate, getSortedData} from '../../../utility/index';

const DATA_SOURCE_TABLE_COLUMNS = [
  { key: "id", value: "ID" },
  { key: "name", value: "Name" },
  { key: "auditable_type", value: "Auditable Type" },
  { key: "auditable_id", value: "Auditable ID" },
  { key: "event", value: "Event" },
  { key: "status", value: "Status" },
  { key: "message", value: "Message" },
  { key: "import_type", value: "Import Type" },
  { key: "filename", value: "Filename" },
  { key: "timestamp", value: "Timestamp" },
  { key: "created_at", value: "Created" },
  { key: "updated_at", value: "Updated" }
];


function DataSourceHistory() {

  const dispatch = useDispatch();
  const { company } =  useSelector(state => state.company);
  const { dataSourceHistory, isLoading } = useSelector(state => state.dataSources);
  const [currentPage, setCurrentPage] = useState(1)
  const { historyData,  totalPages, pageSize, } = dataSourceHistory;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(null);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
};
const createSortHandler = (property) => () => {
    handleRequestSort(property);
};

  const sortedData = React.useMemo(() => {
    return getSortedData(orderBy, order, historyData);
  }, [order, orderBy, historyData]);  

  useEffect(() => {
      if (company.id && currentPage) {
         dispatch(dataSourceHistoryByPage({ companyId: company.id, page: currentPage || 1 }));
      }

  }, [company.id, dispatch, currentPage, totalPages, pageSize]);
  

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
};

const handleNextClick = () => {
    if (currentPage < totalPages) {
        handlePageChange(_, currentPage + 1);
    }
};

const handlePreviousClick = () => {
    if (currentPage > 1) {
        handlePageChange(_, currentPage - 1);
    }
}

  const handleStatusColor = (type, status) => {
    if (type === 'bg') {
      return status?.toLowerCase() === 'started'
        ? '#FFFAEB'
        : status?.toLowerCase() === 'complete'
          ? '#ECFDF3'
          : '#FEF3F2';
    } else {
      return status?.toLowerCase() === 'started'
        ? '#B54708'
        : status?.toLowerCase() === 'complete'
          ? '#027A48'
          : '#B42318';
    }
  }

  const renderNoHistoryData = () => {
    return (
        <TableRow>
            <TableCell colSpan={13}>
                <Box textAlign="center" p={3}>
                    <Typography className="text-sm-regular gray-900">
                        No history data to display
                    </Typography>
                </Box>
            </TableCell>
        </TableRow>
    );
};

const renderHistoryData = () => {
  return historyData?.length > 0
      ? sortedData?.map((row, index) => {
              return (
                  <>
                 <TableRow key={index}>
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-500'
                        >
                          {row.id}
                        </TableCell>
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-900'
                        >
                          {row.name}
                        </TableCell>
                        {/* Auditable Type */}
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-500'
                        >
                          {row.auditable_type}
                        </TableCell>
                        {/* Auditable ID */}
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-500'
                        >
                          {row.auditable_id}
                        </TableCell>
                        {/* Event */}
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-500'
                        >
                          {row.event}
                        </TableCell>
                        {/* Status */}
                        <TableCell
                          align='left'
                        >
                          <Box
                          className="padding-tb-2-r-8-l-6 br-16px flex-row-center gap-4"
                            sx={{background: handleStatusColor('bg', row.status)}}>
                            <Box className="br-50 wh-8px " sx={{
                              background: handleStatusColor('text', row.status)
                            }} />
                            <Typography
                             className='text-2xs-regular'
                              sx={{
                                color: handleStatusColor('text', row.status),
                              }}>
                              {row.status}
                            </Typography>
                          </Box>
                        </TableCell>
                        {/* Message */}
                        <TableCell align='left'>
                          <Box className="wordbreak-break-word">
                            <Typography
                               className='text-2xs-regular gray-500'
                            >
                              {row.message}
                            </Typography>
                          </Box>
                        </TableCell>
                        {/* Import Type */}
                        <TableCell
                          align='left'
                        >
                          <Box className="flex-wrap">
                            <Typography
                            className='text-2xs-regular gray-500'>
                              {row.import_type}
                            </Typography>
                          </Box>
                        </TableCell>
                        {/* FileName */}
                        <TableCell
                          align='left'
                          className='text-2xs-regular gray-500'
                        >
                          {row.filename}
                        </TableCell>
                        {/* TimeStamp */}
                        <TableCell align='left'>
                          <Box>
                              <Typography
                                className='text-2xs-regular gray-900'
                              >
                                
                               {formatDate(row.timestamp)}
                              </Typography>
                          </Box>
                        </TableCell>
                        {/* Created */}
                        <TableCell align='left'>
                          <Box>
                              <Typography
                                className='text-2xs-regular gray-900'
                              >
                                {formatDate(row.created_at)}
                              </Typography>
      
                          </Box>
                        </TableCell>
                        {/* Updated */}
                        <TableCell align='left'>
                          <Box >
                           
                              <Typography
                               className='text-2xs-regular gray-900'
                              >
                                {formatDate(row.updated_at)}
                              </Typography>
            
                          </Box>
                        </TableCell>
                      </TableRow>
              </>) 
              })
      : renderNoHistoryData();
};

  return (
    <>
      {/* Sources History */}
      <Box className="mb-32px" >
        <Typography className='text-500fw-24fs-32lh'>
          Sources History
        </Typography>
      </Box>
      <Grid container spacing={'32px'}>
        {/* Sources History Table */}
        <Grid item xs={12}>
          <Box className="b1px-border-box-br8px">
            {/* Table */}
            <Box data-testid="data_source_history_table">
              <TableContainer component={Paper} className='no-box-shadow no-border'>
                <Table>
                  <TableHead>
                    <TableRow>
                      {DATA_SOURCE_TABLE_COLUMNS.map((column, index) => (
                        <TableCell
                          key={index}
                          align='left'
                          style={{

                          }}
                          className='text-500fw-12fs-18lh bg-gray-50'
                        >
                          <TableSortLabel
                            active={orderBy === column.key}
                            direction={orderBy === column.key ? order : 'asc'}
                            onClick={createSortHandler(column.key)}
                          >
                            {column.value}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                  </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <TableRowsSkeleton
                        rows={10}
                        columns={12}
                      />
                    ) : (
                      renderHistoryData()
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Table Footer */}
            {totalPages ? (
                <Box className="padding-tb-16-rl-24 border-top-gray">
                    <Box className="flex-row-space-between-center">
                        <Box>
                            <CustomButton
                                title="Previous"
                                titleColor="#344054"
                                buttonColor="#FFFFFF"
                                icon={<ArrowLeftIcon />}
                                customStyle={{ borderRadius: '8px' }}
                                handleClick={handlePreviousClick}
                                buttonDisabled={!(currentPage !== 1)}
                            />
                        </Box>

                        {/* Pagination */}
                        <Box>
                            <Pagination
                                shape="rounded"
                                count={totalPages}
                                page={currentPage}
                                hidePrevButton
                                hideNextButton
                                onChange={(e, value)=>handlePageChange(e,value)}
                            />
                        </Box>

                        <Box>
                            <CustomButton
                                title="Next"
                                titleColor="#344054"
                                buttonColor="#FFFFFF"
                                tailIcon={<ArrowRightIcon />}
                                customStyle={{ borderRadius: '8px' }}
                                handleClick={handleNextClick}
                                buttonDisabled={!(totalPages > currentPage)}
                            />
                        </Box>
                    </Box>
                </Box>
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default DataSourceHistory;